var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82949 3.35391C8.89805 3.29941 9 3.35039 9 3.43652V7.03125C9 7.49707 8.62207 7.875 8.15625 7.875H0.84375C0.37793 7.875 0 7.49707 0 7.03125V3.43828C0 3.35039 0.100195 3.30117 0.170508 3.35566C0.564258 3.66152 1.08633 4.05 2.8793 5.35254C3.2502 5.62324 3.87598 6.19277 4.5 6.18926C5.12754 6.19453 5.76562 5.6127 6.12246 5.35254C7.91543 4.05 8.43574 3.65977 8.82949 3.35391ZM4.5 5.625C4.90781 5.63203 5.49492 5.11172 5.79023 4.89727C8.12285 3.20449 8.30039 3.05684 8.83828 2.63496C8.94023 2.55586 9 2.43281 9 2.30273V1.96875C9 1.50293 8.62207 1.125 8.15625 1.125H0.84375C0.37793 1.125 0 1.50293 0 1.96875V2.30273C0 2.43281 0.0597656 2.5541 0.161719 2.63496C0.699609 3.05508 0.877149 3.20449 3.20977 4.89727C3.50508 5.11172 4.09219 5.63203 4.5 5.625Z",
    fill: "black",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.4421063c5eaa1c982b8859fbb7fa14b1.svg";
export { ForwardRef as ReactComponent };